export   const maskAccountNumber = (accountNumber) => {
    const numStr = accountNumber.toString();
    if (numStr.length <= 4) return numStr;
    return 'X'.repeat(numStr.length - 4) + numStr.slice(-4);
  };